import client from "src/api/client";
import type { ComplianceUserActionHandler } from "src/components/UserActions/Handlers/Compliance/types";

const DOCUMENT_COMPLIANCE_OVERRIDE_ENTRY_KEY = "documentComplianceOverride";
const REJECT_DOCUMENT_COMPLIANCE_ENTRY_VALUE = "REJECT";

const handleForceReject: ComplianceUserActionHandler = async (
  documentDetails
) => {
  const { overriddenMetadataIndexStarted } =
    await client.saveOverriddenMetadata({
      documentType: documentDetails.documentType,
      documentId: documentDetails.documentId,
      countryCode: documentDetails.countryCode,
      attributes: {
        [DOCUMENT_COMPLIANCE_OVERRIDE_ENTRY_KEY]:
          REJECT_DOCUMENT_COMPLIANCE_ENTRY_VALUE,
      },
      shouldRestartComplianceProcess: true,
    });

  return overriddenMetadataIndexStarted;
};

export default handleForceReject;
